import { fetchAdminPropertiesAction } from 'redux/actions/propertiesActions';

const defaultState = {
    data: [],
    pagination: {},
    areLoading: true,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case fetchAdminPropertiesAction.REQUEST:
            return { ...state, areLoading: true };
        case fetchAdminPropertiesAction.SUCCESS:
            return { ...state, data: action.payload.data, pagination: action.payload.pagination };
        case fetchAdminPropertiesAction.FULFILL:
            return { ...state, areLoading: false };
        default:
            return { ...state };
    }
};
